const actions = {
  setTicker: 'setTicker',
  setLoading: 'setLoading',
  setDateFilters: 'setDateFilters',
  setData: 'setData',
  setFundList: 'setFundList',
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.setLoading:
      return {
        ...state,
        loading: action.value,
      };
    case actions.setTicker:
      return {
        ...state,
        fundData: action.value,
        filters: {
          ...state.filters,
          ticker: action.value.bloombergTickerPrimary || action.value.bloombergTicker,
        },
      };
    case actions.setDateFilters:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.value,
        },
      };
    case actions.setData:
      return {
        ...state,
        loading: false,
        data: action.value,
      };
    case actions.setFundList:
      return {
        ...state,
        loading: false,
        fundList: action.value,
      };
    default:
      throw new Error();
  }
};

export { reducer, actions };
